module.exports = __webpack_public_path__ + "img/weddings_07_H.df61dfd1.webp";